﻿let promiseResolveFunction;
let promiseRejectFunction;

/**
 * Allow the Google reCAPTCHA scripts a period of time to load, after which we will assume something
 * has gone wrong and therefore reject the promise.
 */
const timeoutFunction = setTimeout(function rejectPromiseAfterTimeout() {
  promiseRejectFunction(new Error('The Google reCAPTCHA script did\'t finish loading in the time allocated'));
}, 15 * 1000);

const recaptchaPromise = new Promise(function (resolve, reject) {
  promiseResolveFunction = resolve;
  promiseRejectFunction = reject;
});

/**
 * Create a global function on the window object that can be used as a callback for Google reCAPTCHA
 * after it has loaded.
 * www.google.com/recaptcha/api.js?onload=publicPortalHandleRecaptchaLoaded&render=explicit
 *
 * The long function name is to ensure this global variable is unique. This is an exceptional case
 * and we never normally want to create global / window objects.
 */
window.publicPortalHandleRecaptchaLoaded = function () {
  clearTimeout(timeoutFunction);
  promiseResolveFunction(grecaptcha);
};

export default class RecaptchaHelper {

  /**
   * Returns a promise for the Google reCAPTCHA object
   * @return {Promise}
   */
  public static async getRecaptcha() {
    return recaptchaPromise;
  }
}

